export default {
  menu: 'Variants',
  title: 'Variants',

  general: {
    labels: {
      name: 'Title',
      slug: 'Slug',
      archive: 'Enable archives?',
      value: 'Value',
      values: 'Values:',
      insertValue: 'Add new value',
      editValue: 'Edit value',
      categories: 'Categories:',
      shops: 'Sites:',
      delete: 'Delete Variant',
      withoutCategory: 'Without category'
    },

    validators: {
      name: 'Variant name can not be longer than {num} characters',
      slug: 'Variant slug can not be longer than {num} characters',
      value: 'Variant value can not be more than {num} characters',
      valueSlug: 'Variant value slug can not be more than {num} characters',
      nameRequired: 'Title field is required',
      valueRequired: 'Value field is required',
      slugRequired: 'Slug field is required',
      noChange: 'No changes have been made',
      delete: 'The desired variant can not be deleted'
    },

    notifications: {
      insert: {
        success: 'New variant successfully registered',
        error: 'Registering a new variant with an error'
      },
      insertValue: {
        success: 'New value saved successfully',
        error: 'Saved new value failed'
      },


      edit: {
        success: 'Variant successfully edited',
        error: 'Variant editing encountered error'
      },
      editValue: {
        success: 'Variant value successfully updated',
        error: 'Updating new value failed'
      },

      delete: {
        success: 'The variant was successfully removed',
        error: 'Variant delete accompanied by error'
      },
      deleteValue: {
        success: 'The variant value was successfully removed',
        error: 'Variant value delete accompanied by error'
      },

      setProperties: {
        success: 'Variant prioritization was done successfully',
        error: 'Variant prioritization has error'
      },

      parseError: {
        slug: 'Slug has already been used'
      }
    },

    confirmations: {
      delete: {
        title: 'Delete variant',
        body: 'Are you sure you want to delete the variant {name}?'
      },
      deleteValue: {
        title: 'Delete variant value',
        body: 'Are you sure you want to delete the variant value {name}?'
      }
    }
  },

  list: {
    title: 'Variants List',

    table: {
      header: {
        rowNumber: 'Row',
        name: 'Variant name',
        values: 'Variant values',
        categories: 'Variant categories',
        productCount: 'Product count'
      }
    }
  },

  insert: {
    title: 'Add new variant'
  },

  edit: {
    title: 'Edit variant'
  },

  profile: {
    title: 'Variant profile'
  },

  setProperties: {
    title: 'Variant properties',

    statusTable: {
      loading: 'Loading ...',
      error: 'Error in receiving info'
    }
  },

  values: {
    table: {
      header: {
        row: 'Row',
        name: 'Name',
        slug: 'Slug',
        update: 'Update',
        delete: 'Delete',
        products: 'Products'
      }
    }
  },

  select: {
    table: {
      header: {
        select: 'Select',
        name: 'Variant name',
        values: 'Variant values'
      }
    }
  }
}
